import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SuppliersService } from '../../../shared/API-Service/services/suppliers.service';
import Swal from 'sweetalert2';
import {BaseComponent } from '../../../../app/shared/components/base/base.component'
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment.prod';
@Component({
  selector: 'app-suppliers',
  templateUrl: './suppliers.component.html',
  styleUrls: ['./suppliers.component.css']
})
export class SuppliersComponent extends BaseComponent implements OnInit {
  suppliers: any;
  closeResult: string;
  commercialRegisteration: any;
  electronicCard: string;
  taxCard: string;
  vatRegisterationCertificate: string;

  constructor(public modalService: NgbModal,private SuppliersService:SuppliersService,private _Router:Router) { super()}
  ngOnInit(): void {
    this.getSuppliers();
    
  }
  pageChanged(event: any){
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
    this.getSuppliers()

  }
  getSuppliers(){
    const data={
      "maxResultCount": this.pager.maxResultCount,
      "skipCount": this.pager.skipCount,
    }
    this.SuppliersService.GetSuppliersPaged(this.pager).subscribe((res) => {
      this.suppliers = res.data.items
      this.totalCount=res.data.totalCount;
    console.log(this.suppliers);
    
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }

  open(content,item) {
    console.log(item)
    this.commercialRegisteration=""
    this.electronicCard=""
    this.taxCard=""
    this.vatRegisterationCertificate=""

    this.commercialRegisteration=environment.ServerImages_URL+'/'+item.commercialRegisteration
    this.electronicCard=environment.ServerImages_URL+'/'+item.electronicCard
    this.taxCard=environment.ServerImages_URL+'/'+item.taxCard
    this.vatRegisterationCertificate=environment.ServerImages_URL+'/'+item.vatRegisterationCertificate
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true,size: 'xl'  }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
 private getDismissReason(reason: any): string {
  
    if (reason === ModalDismissReasons.ESC) {

      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      console.log(reason)
      return `with: ${reason}`;
    }
  }

  modalclose(){
    this.modalService.dismissAll();
  }
OpenImage(imagesView){
    Swal.fire({
      imageUrl: imagesView,
      imageHeight: 400,
      imageAlt: 'A tall image',
      confirmButtonText:"الغاء"
    })
  }
  // update(id){
  //   console.log(id);
  //   //this.PartnersService.Data.next(data);
  //   // this._Router.navigate(['/content/admin/insert-partner']);
  //   this._Router.navigate(['/content/admin/update-partner',id]);
  //   }

    // delete(id : number){
    //   Swal.fire({
    //     title: 'هل تريد مسح العنصر ؟',
    //     text: "لن يكون لك صلاحية إعادته مره اخرى",
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     cancelButtonText: 'الغاء',
    //     confirmButtonText: 'امسح العنصر !'
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.PartnersService.DeletePartner(id).subscribe((res) => {
    //         Swal.fire({
    //           icon: "success",
    //           title: "تم المسح بنجاح",
    //           showConfirmButton: false,
    //           timer: 1500,
    //         });
    //      this.getSuppliers();
    //       },(err) => {
    //         Swal.fire({
    //           icon: 'error',
    //           title: 'خطأ',
    //           text:err.error.message    
    //         })
    //       },() => {
    //         console.log("completed");
    //       })
    //     }
    //   }) 
    // }
    GotoDetails(item){
      this._Router.navigate(['/content/admin/SupplierDetails',item.id]);
    }

}
